
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Customer } from "@/pages/dashboard/Customers";
import { Edit, Mail, Phone } from "lucide-react";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";

interface CustomerTableProps {
  customers: Customer[];
  onSelectCustomer: (customer: Customer) => void;
  isLoading?: boolean;
}

export function CustomerTable({ customers, onSelectCustomer, isLoading }: CustomerTableProps) {
  if (isLoading) {
    return <div className="text-center py-4">Loading customers...</div>;
  }

  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Customer</TableHead>
            <TableHead>Contact</TableHead>
            <TableHead>Last Visit</TableHead>
            <TableHead>Appointments</TableHead>
            <TableHead>Consent</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {customers.map((customer) => (
            <TableRow key={customer.id}>
              <TableCell className="font-medium">{customer.name}</TableCell>
              <TableCell>
                <div className="space-y-1">
                  <div className="flex items-center text-sm text-muted-foreground">
                    <Mail className="h-4 w-4 mr-2" />
                    {customer.email}
                  </div>
                  <div className="flex items-center text-sm text-muted-foreground">
                    <Phone className="h-4 w-4 mr-2" />
                    {customer.phone}
                  </div>
                </div>
              </TableCell>
              <TableCell>
                {customer.lastVisit 
                  ? format(customer.lastVisit, "MMM d, yyyy")
                  : "Never"
                }
              </TableCell>
              <TableCell>{customer.appointmentCount}</TableCell>
              <TableCell>
                <div className="flex gap-1">
                  <Badge variant={customer.smsConsent ? 'default' : 'secondary'} className="text-[10px]">
                    SMS {customer.smsConsent ? 'Allowed' : 'Blocked'}
                  </Badge>
                  <Badge variant={customer.marketingConsent ? 'default' : 'secondary'} className="text-[10px]">
                    Mktg {customer.marketingConsent ? 'Opt-in' : 'Opt-out'}
                  </Badge>
                </div>
              </TableCell>
              <TableCell>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onSelectCustomer(customer)}
                >
                  <Edit className="h-4 w-4 mr-2" />
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
